import React, { useState } from 'react';
import { Box, Grid, useMediaQuery } from '@mui/material';
import CommentList from './CommentList';
import CommentForm from './CommentForm';
import { useTheme } from '@emotion/react';

const Comments = () => {
  const [editingComment, setEditingComment] = useState(null);
    const theme = useTheme();
      const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Grid container sx={{ position: 'relative', display: 'grid', gridTemplateRows: '1fr',height:"100%" }}>
      <Grid item xs={12} sx={{ position: 'relative', display: 'grid',height:"90%",overflowY:"scroll" }}>
        <CommentList setEditingComment={setEditingComment} />
      </Grid>
      <Grid item xs={12} sx={{ position: 'absolute', bottom: 0, left: 0, right: 0 ,height:"10%" }}>
        <CommentForm editingComment={editingComment} setEditingComment={setEditingComment} />
      </Grid>
    </Grid>
  );
};

export default Comments;
